/**
 * TanStack Query hooks for `per-sub-network-user-entitlements`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	perSubNetworkUserEntitlementsQueryKeys,
	type CreatePerSubNetworkUserEntitlementsBody,
	type ListPerSubNetworkUserEntitlementsResponse,
	type PerSubNetworkUserEntitlementsRow,
} from "./api";

export function usePerSubNetworkUserEntitlementsList(): UseQueryResult<ListPerSubNetworkUserEntitlementsResponse, Error> {
	return useQuery({
		queryKey: perSubNetworkUserEntitlementsQueryKeys.list(),
		queryFn: list,
	});
}

export function usePerSubNetworkUserEntitlementsCreate(): UseMutationResult<PerSubNetworkUserEntitlementsRow, Error, CreatePerSubNetworkUserEntitlementsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: perSubNetworkUserEntitlementsQueryKeys.all });
		},
	});
}

export function usePerSubNetworkUserEntitlementsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: perSubNetworkUserEntitlementsQueryKeys.all });
		},
	});
}
